import React, { useEffect, useState } from "react";
import { getMetricById } from "../../../services/MetricService";
import { Header, MetricProto } from "build-ts/metadata";
import showToast from "hooks/useCustomToast";
import MKGVisualizer from "components/configuration/mkg/MKGVisualizer";

/**
 * 
 * Manages the state and logic for visualizing graphs based on a given metric ID.
 * Renders the VisualizeGraphDumb component to display the graph.
 * 
 * @component
 * @param {Header} metricId - The ID of the metric to visualize.
 */

const MKGVisualizerContainer: React.FC<{ metricId?: Header }> = ({ metricId }) => {
  // State variable
  const [useMetricKnowledge, setMetricKnowledge] = useState<MetricProto>();

  // UseEffect hook to fetch metric details when the metricId changes
  useEffect(() => {
    const fetchMK = async () => {
      try {
        if (metricId?.id !== undefined) {
          //second paramenter is to include edges or not. If true then edges will also be returned
          const data = await getMetricById(metricId.id, true);
          if (data !== null) {
            setMetricKnowledge(data);
          }
        }
      } catch {
        showToast("Error while Fetching the details", "", "error");
      }
    };
    fetchMK();
  }, [metricId?.id]);

  return <MKGVisualizer useMetricKnowledge={useMetricKnowledge} />;
};

export default MKGVisualizerContainer;
